import { capitalize } from '@mui/material';
import { GlobalVisaType } from 'API';
import { resolvers } from 'shared/enums';

const visaTypeResolver = resolvers.GlobalVisaType;

/** The label stored for a visa type captured on intake — “Business Visa”. */
export const globalVisaTypeLabel = (
  visaType: GlobalVisaType,
) => `${visaTypeResolver(visaType)} Visa`;

/** The subcategory is stored as free text — “Pakistan - Business Visa”. */
export const buildGlobalSubCategory = (
  countryName: string, visaTypeLabel: string,
) => `${countryName} - ${capitalize(visaTypeLabel.trim())}`;

/**
 * Intake offers a fixed set of visa types, but the subcategory has always been
 * free text and the practice uses many more of them — “Visitor Visa”, “CSEP”,
 * “Skilled Worker”. The intake options are offered as suggestions only, and the
 * enum is recorded only while the label still agrees with it.
 */
export const matchGlobalVisaType = (label: string) => Object.values(GlobalVisaType)
  .find((type) => globalVisaTypeLabel(type).toLowerCase() === label.trim().toLowerCase())
  || null;
